<mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
    <!-- <mat-card-header>
        <app-card-title>{{ "general_information" | translate }}</app-card-title>
    </mat-card-header> -->
    <mat-card-content class="card-content">

        <table class="table table-bordered">
            <colgroup>
                <col style="width: 20%">
                <col style="width: 40%">
                <col style="width: 20%">
                <col style="width: 20%">
            </colgroup>
            <tbody>
            <tr>
                <th class="table-active"> {{ "title1" | translate }}</th>
                <td colspan="3">

                    <span *ngIf="current_lang=='ar'"> {{item.title2}}</span>
                    <span *ngIf="current_lang=='fr'"> {{item.title1}}</span>
                    <span *ngIf="current_lang=='en'"> {{item.titleEn}}</span>

                </td>
            </tr>
            <tr>
                <th class="table-active">{{ "id_rédacteur" | translate }}</th>
                <td> {{item.writerId}}</td>
                <th class="table-active">{{ "moderNm" | translate }}</th>
                <td>{{item.writerNm}}</td>
            </tr>
            <tr>
                <th class="table-active">{{ "hitCnt" | translate }}</th>
                <td>{{item.hitCnt}}</td>
                <th class="table-active">{{ "date_redaction" | translate }}</th>
                <td>{{item.regDt | date : 'dd/MM/yyyy' }}</td>
            </tr>
            <tr>
                <th class="table-active">{{ "Contenus" | translate }}</th>
                <td colspan="3" style="vertical-align:top;">
                    <!--   {{item.cont1}} -->


                    <div [innerHtml]="current_lang=='ar'?(item.cont2|safehtml):(item.cont1|safehtml)"></div>

                </td>
            </tr>
            <tr>
                <th class="table-active">{{"Fichiers attachés" | translate}}</th>
                <td *ngIf="fileitems" colspan="3">

                    <a (click)="downloadFile(fileitem.nodeRef, fileitem.originFileNm, fileitem.fileUrl)" *ngFor="let fileitem of fileitems"
                       style="color: blue;">
                        {{fileitem?.originFileNm}} &nbsp;({{fileitem?.fileSize}} KB)
                        <br>
                    </a>


                </td>
            </tr>
            </tbody>
        </table>
        <div *ngIf="current_lang=='fr'|| current_lang=='en'" align="right">
            <button [routerLink]="['/portail/news']" mat-raised-button
                    style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
        </div>
        <div *ngIf="current_lang=='ar'" style="float: left;">
            <button [routerLink]="['/portail/news']" mat-raised-button
                    style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
        </div>
    </mat-card-content>
</mat-card>


